// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubProfileCard-cls1__cd9d9d4d113776764c0e","cls2":"ImpactHubProfileCard-cls2___12a81a35d7009ad2252 ImpactHubProfileCard-cls1__cd9d9d4d113776764c0e"};